// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialSection_root__3yDCe","icon":"SocialSection_icon__4XczO"};